const LOCAL_STORAGE_AUTH_TOKEN_KEY = 'token';

export default class LocalStorageService {
  static getAuthorizationToken() {
    return localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
  }

  static setAuthorizationToken(token: string) {
    return localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN_KEY, token);
  }

  static removeAuthorizationToken() {
    return localStorage.removeItem(LOCAL_STORAGE_AUTH_TOKEN_KEY);
  }
}
